import Geocode from 'react-geocode';

Geocode.setApiKey(process.env.GOOGLE_API_KEY);

export async function fromAddress(address) {
  const response = await Geocode.fromAddress(address);
  const { lat, lng } = response.results[0].geometry.location;
  return { lat, lng };
}
